import React from "react";
import Image from "next/image";

const CommonBanner = ({ name, className = "" }) => {
  return (
    <div
      className={`relative w-full h-[390px] flex items-end justify-start pb-[40px] lg:pb-[60px] ${className}`}
    >
      {/* Optimized background image */}
      <Image
        src="/banners/commonbanner.webp"
        alt="prism digital marketing agency Common Banner"
        layout="fill"
        objectFit="cover"
        objectPosition="top"
        priority
        quality={75}
      />

      {/* Overlay content */}
      <div className="relative z-10 w-full md:w-2/3 px-[24px] sm:px-[60px] md:px-[60px] lg:px-[80px] xl:px-[80px]">
        <h1 className="m-0 leading-[120%] font-medium text-[36px] sm:text-[40px] lg:text-[55px] w-full max-w-full break-words text-white capitalize">
          {name}
        </h1>
      </div>

      {/* Optional dark overlay for readability */}
      <div className="absolute inset-0 bg-black/40 z-0" />
    </div>
  );
};

export default CommonBanner;
